import svgPaths from "../imports/svg-81637b3w7q";
import { useState, useRef, useEffect } from "react";

import { Textarea } from "./ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { ToggleGroup, ToggleGroupItem } from "./ui/toggle-group";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Label } from "./ui/label";
import { Input } from "./ui/input";

function VuesaxLinearArrowLeft() {
  return (
    <div className="absolute contents inset-0" data-name="vuesax/linear/arrow-left">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
        <g id="arrow-left">
          <path d="M9.57 5.93L3.5 12L9.57 18.07" id="Vector" stroke="var(--stroke-0, #292D32)" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" />
          <path d="M20.5 12H3.67" id="Vector_2" stroke="var(--stroke-0, #292D32)" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.5" />
          <g id="Vector_3" opacity="0"></g>
        </g>
      </svg>
    </div>
  );
}

function ArrowLeft({ onClick }: { onClick?: () => void }) {
  return (
    <div onClick={onClick} className="relative shrink-0 size-[24px] cursor-pointer" data-name="arrow-left">
      <VuesaxLinearArrowLeft />
    </div>
  );
}

function Edit() {
  return (
    <div className="relative shrink-0 size-[16px]" data-name="edit-02">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 16 16">
        <g id="edit-02">
          <path d={svgPaths.p19317580} id="Icon" stroke="var(--stroke-0, #475367)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
        </g>
      </svg>
    </div>
  );
}

function Frame11({ appName, onAppNameChange }: { appName: string; onAppNameChange: (name: string) => void }) {
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  return (
    <div className="content-stretch flex gap-[8px] items-center relative shrink-0">
      <div className="content-stretch flex items-center relative shrink-0">
        {isEditing ? (
          <input
            ref={inputRef}
            value={appName}
            onChange={(e) => onAppNameChange(e.target.value)}
            onBlur={() => setIsEditing(false)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') setIsEditing(false);
            }}
            className="css-ew64yg font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[#1d2739] text-[16px] bg-transparent outline-none min-w-[150px] border-b border-[#30A84B]"
          />
        ) : (
          <p className="css-ew64yg font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] not-italic relative shrink-0 text-[#1d2739] text-[16px]">{appName}</p>
        )}
      </div>
      <div onClick={() => setIsEditing(true)} className="cursor-pointer hover:bg-gray-100 rounded p-1">
        <Edit />
      </div>
    </div>
  );
}

function Frame10({ onBack, appName, onAppNameChange }: { onBack?: () => void; appName: string; onAppNameChange: (name: string) => void }) {
  return (
    <div className="content-stretch flex gap-[16px] items-center relative shrink-0">
      <ArrowLeft onClick={onBack} />
      <Frame11 appName={appName} onAppNameChange={onAppNameChange} />
    </div>
  );
}

function PrimarySm({ isActive, onClick }: { isActive?: boolean; onClick?: () => void }) {
  return (
    <div
      onClick={isActive ? onClick : undefined}
      className={`${isActive ? "bg-[#30A84B] cursor-pointer" : "bg-[#bfe4c7] cursor-not-allowed"} content-stretch flex gap-[4px] h-[36px] items-center justify-center p-[12px] relative rounded-[6px] shrink-0 w-[100px] transition-all duration-200`}
      data-name="Primary - Sm"
    >
      <p className="css-ew64yg font-['Inter:Medium',sans-serif] font-medium leading-[normal] not-italic relative shrink-0 text-[14px] text-white">Create</p>
    </div>
  );
}

function Frame7({ isActive, onCreate }: { isActive?: boolean; onCreate?: () => void }) {
  return (
    <div className="content-stretch flex items-center relative shrink-0">
      <PrimarySm isActive={isActive} onClick={onCreate} />
    </div>
  );
}

function Frame21({ isActive, onCreate }: { isActive?: boolean; onCreate?: () => void }) {
  return (
    <div className="content-stretch flex items-center justify-end relative shrink-0">
      <Frame7 isActive={isActive} onCreate={onCreate} />
    </div>
  );
}

function NavHeader({ onBack, isActive, onCreate, appName, onAppNameChange }: { onBack?: () => void; isActive?: boolean; onCreate?: () => void; appName: string; onAppNameChange: (name: string) => void }) {
  return (
    <div className="relative bg-white h-[68px] w-full shrink-0" data-name="Nav Header">
      <div className="content-stretch flex items-center justify-between overflow-clip px-[20px] py-[16px] relative rounded-[inherit] size-full">
        <Frame10 onBack={onBack} appName={appName} onAppNameChange={onAppNameChange} />
        <Frame21 isActive={isActive} onCreate={onCreate} />
      </div>
      <div aria-hidden="true" className="absolute border-[#e4e7ec] border-b-[0.5px] border-solid inset-[0_0_-0.5px_0] pointer-events-none" />
    </div>
  );
}









function Frame25({ value, onChange }: { value: string; onChange: (val: string) => void }) {
  return (
    <div className="flex flex-col gap-[8px] w-full">
      <p className="font-['Inter'] font-normal leading-[0] not-italic relative shrink-0 text-[#101928] text-[14px]">
        <span className="leading-[24px]">Content Description</span>
        <span className="leading-[24px] text-[#f04438]">*</span>
      </p>
      <Textarea
        placeholder="Enter content description"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="h-[159px] w-full rounded-[6px] border-[#e4e7ec] bg-white px-[12px] py-[16px] text-[14px] placeholder:text-[#98a2b3] shadow-none resize-none focus-visible:ring-0 focus-visible:border-[#0ba29b]"
      />
    </div>
  );
}

















function DropdownIcon() {
  return (
    <div className="relative shrink-0 size-[20px]" data-name="Dropdown">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
        <g id="Dropdown">
          <path d="M5 7.5L10 12.5L15 7.5" id="Icon" stroke="#667185" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
        </g>
      </svg>
    </div>
  );
}

function Frame27({
  fontWeight,
  setFontWeight,
  fontFamily,
  setFontFamily,
}: {
  fontWeight: string;
  setFontWeight: (val: string) => void;
  fontFamily: string;
  setFontFamily: (val: string) => void;
}) {
  const weights = ["100", "200", "300", "400", "500", "600", "700", "800", "900"];
  const fonts = ["Inter", "Roboto", "Open Sans", "Lato", "Montserrat", "Poppins", "Bricolage Grotesque", "Segoe UI"];

  return (
    <div className="flex gap-4 w-full">
      <div className="flex flex-col gap-[8px] flex-1">
        <p className="font-['Inter'] font-normal leading-[0] not-italic relative shrink-0 text-[#101928] text-[14px]">
          <span className="leading-[24px]">Font Weight</span>
          <span className="leading-[24px] text-[#f04438]">*</span>
        </p>
        <Select value={fontWeight} onValueChange={setFontWeight}>
          <SelectTrigger className="h-[40px] rounded-[6px] border-[#e4e7ec] bg-white px-[8px] py-[8px] [&>svg:last-child]:hidden shadow-none">
            <SelectValue placeholder="500" />
            <DropdownIcon />
          </SelectTrigger>
          <SelectContent>
            {weights.map((w) => (
              <SelectItem key={w} value={w}>
                {w}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex flex-col gap-[8px] flex-1">
        <p className="font-['Inter'] font-normal leading-[0] not-italic relative shrink-0 text-[#101928] text-[14px]">
          <span className="leading-[24px]">Font Family</span>
          <span className="leading-[24px] text-[#f04438]">*</span>
        </p>
        <Select value={fontFamily} onValueChange={setFontFamily}>
          <SelectTrigger className="h-[40px] rounded-[6px] border-[#e4e7ec] bg-white px-[8px] py-[8px] [&>svg:last-child]:hidden shadow-none">
            <SelectValue placeholder="Inter" />
            <DropdownIcon />
          </SelectTrigger>
          <SelectContent>
            {fonts.map((f) => (
              <SelectItem key={f} value={f}>
                {f}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}









function ColorPicker({ color, onChange }: { color: string; onChange: (val: string) => void }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="flex gap-2 items-center cursor-pointer p-1 rounded hover:bg-gray-100">
          <div className="w-6 h-6 rounded-full border border-gray-200" style={{ backgroundColor: color }} />
          <span className="text-sm font-medium uppercase">{color}</span>
        </div>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-3">
        <div className="flex flex-col gap-2">
          <div className="flex gap-2 items-center">
            <div className="w-10 h-10 rounded-md overflow-hidden border border-gray-200 relative">
              <input
                type="color"
                value={color}
                onChange={(e) => onChange(e.target.value)}
                className="absolute inset-0 w-[150%] h-[150%] -top-[25%] -left-[25%] p-0 border-0 cursor-pointer"
              />
            </div>
            <Input value={color} onChange={(e) => onChange(e.target.value)} className="h-10 flex-1" />
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}

function CustomAlignLeft({ isActive }: { isActive: boolean }) {
  if (!isActive) {
    return (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 20 20">
        <path d="M2.5 3.75H17.5" stroke="#667185" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
        <path d="M2.5 7.91667H10.3917" stroke="#667185" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
        <path d="M2.5 12.0833H17.5" stroke="#667185" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
        <path d="M2.5 16.25H10.3917" stroke="#667185" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
      </svg>
    );
  }
  return (
    <svg className="w-5 h-5" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
      <g>
        <path d="M2.5 3.75H17.5" stroke="url(#paint0_left)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
        <path d="M2.5 7.91667H10.3917" stroke="url(#paint1_left)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
        <path d="M2.5 12.0833H17.5" stroke="url(#paint2_left)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
        <path d="M2.5 16.25H10.3917" stroke="url(#paint3_left)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
      </g>
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint0_left" x1="10" x2="10" y1="3.75" y2="4.75">
          <stop stopColor="#0BA29B" />
          <stop offset="1" stopColor="#43B48D" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint1_left" x1="6.44583" x2="6.44583" y1="7.91667" y2="8.91667">
          <stop stopColor="#0BA29B" />
          <stop offset="1" stopColor="#43B48D" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint2_left" x1="10" x2="10" y1="12.0833" y2="13.0833">
          <stop stopColor="#0BA29B" />
          <stop offset="1" stopColor="#43B48D" />
        </linearGradient>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint3_left" x1="6.44583" x2="6.44583" y1="16.25" y2="17.25">
          <stop stopColor="#0BA29B" />
          <stop offset="1" stopColor="#43B48D" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function CustomAlignCenter({ isActive }: { isActive: boolean }) {
  const stroke = isActive ? "url(#grad_center)" : "#667185";
  return (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 16 16">
      <defs>
        <linearGradient id="grad_center" x1="8" y1="0" x2="8" y2="16" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0BA29B" />
          <stop offset="1" stopColor="#43B48D" />
        </linearGradient>
      </defs>
      <path d="M2 3H14" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M4.84 6.33333H11.16" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M2 9.66667H14" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M4.84 13H11.16" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </svg>
  );
}

function CustomAlignRight({ isActive }: { isActive: boolean }) {
  const stroke = isActive ? "url(#grad_right)" : "#667185";
  return (
    <svg className="w-5 h-5" fill="none" viewBox="0 0 16 16">
      <defs>
        <linearGradient id="grad_right" x1="8" y1="0" x2="8" y2="16" gradientUnits="userSpaceOnUse">
          <stop stopColor="#0BA29B" />
          <stop offset="1" stopColor="#43B48D" />
        </linearGradient>
      </defs>
      <path d="M2 3H14" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M7.68667 6.33333H14" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M2 9.66667H14" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M7.68667 13H14" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </svg>
  );
}

function Frame28({
  alignment,
  setAlignment,
  textColor,
  setTextColor,
  bgColor,
  setBgColor,
}: {
  alignment: string;
  setAlignment: (val: string) => void;
  textColor: string;
  setTextColor: (val: string) => void;
  bgColor: string;
  setBgColor: (val: string) => void;
}) {
  const toggleItemClass =
    "w-[36px] h-[36px] p-0 rounded-[6px] transition-all hover:bg-gray-100 data-[state=on]:bg-gradient-to-b data-[state=on]:from-[rgba(11,162,155,0.1)] data-[state=on]:to-[rgba(67,180,141,0.1)] data-[state=on]:border-none shadow-none border-transparent";

  return (
    <div className="flex gap-8 items-center flex-wrap">
      <div className="flex flex-col gap-2">
        <Label className="text-sm font-medium">Alignment</Label>
        <ToggleGroup type="single" value={alignment} onValueChange={(val) => val && setAlignment(val)}>
          <ToggleGroupItem value="left" aria-label="Left" className={toggleItemClass}>
            <CustomAlignLeft isActive={alignment === "left"} />
          </ToggleGroupItem>
          <ToggleGroupItem value="center" aria-label="Center" className={toggleItemClass}>
            <CustomAlignCenter isActive={alignment === "center"} />
          </ToggleGroupItem>
          <ToggleGroupItem value="right" aria-label="Right" className={toggleItemClass}>
            <CustomAlignRight isActive={alignment === "right"} />
          </ToggleGroupItem>
        </ToggleGroup>
      </div>

      <div className="flex flex-col gap-2">
        <Label className="text-sm font-medium">Text Color</Label>
        <ColorPicker color={textColor} onChange={setTextColor} />
      </div>

      <div className="flex flex-col gap-2">
        <Label className="text-sm font-medium">Background</Label>
        <ColorPicker color={bgColor} onChange={setBgColor} />
      </div>
    </div>
  );
}

interface TextAppSettings {
  content: string;
  setContent: (val: string) => void;
  fontWeight: string;
  setFontWeight: (val: string) => void;
  fontFamily: string;
  setFontFamily: (val: string) => void;
  alignment: string;
  setAlignment: (val: string) => void;
  textColor: string;
  setTextColor: (val: string) => void;
  bgColor: string;
  setBgColor: (val: string) => void;
}

function Frame29(props: TextAppSettings) {
  return (
    <div className="content-stretch flex flex-col gap-[40px] items-start relative shrink-0 w-full">
      <Frame25 value={props.content} onChange={props.setContent} />
      <Frame27
        fontWeight={props.fontWeight}
        setFontWeight={props.setFontWeight}
        fontFamily={props.fontFamily}
        setFontFamily={props.setFontFamily}
      />
      <Frame28
        alignment={props.alignment}
        setAlignment={props.setAlignment}
        textColor={props.textColor}
        setTextColor={props.setTextColor}
        bgColor={props.bgColor}
        setBgColor={props.setBgColor}
      />
    </div>
  );
}

function SecondarySm({ onClick }: { onClick?: () => void }) {
  return (
    <div onClick={onClick} className="cursor-pointer hover:bg-gray-50 transition-colors content-stretch flex gap-[6px] h-[36px] items-center justify-center p-[12px] relative rounded-[6px] shrink-0" data-name="Secondary - Sm">
      <div aria-hidden="true" className="absolute border-[#e4e7ec] border-[0.75px] border-solid inset-0 pointer-events-none rounded-[6px]" />
      <p className="css-ew64yg font-['Inter:Medium',sans-serif] font-medium leading-[normal] not-italic relative shrink-0 text-[#101928] text-[14px]">Preview</p>
    </div>
  );
}

function Frame23({ onPreview, ...props }: TextAppSettings & { onPreview?: () => void }) {
  return (
    <div className="content-stretch flex flex-col gap-[32px] items-end justify-center p-[16px] relative rounded-[6px] flex-1">
      <div aria-hidden="true" className="absolute border border-[#e4e7ec] border-solid inset-0 pointer-events-none rounded-[6px] shadow-[0px_1px_6px_0px_rgba(0,0,0,0.05)]" />
      <p className="css-4hzbpn font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] min-w-full not-italic relative shrink-0 text-[#101928] text-[16px] w-[min-content]">Text Details</p>
      <Frame29 {...props} />
      <SecondarySm onClick={onPreview} />
    </div>
  );
}

function Frame20() {
  return (
    <div className="relative shrink-0 size-[42px]">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 42 42">
        <g id="Frame 1321319050">
          <circle cx="21" cy="21" fill="var(--fill-0, #F0F2F5)" id="Ellipse 2365" r="21" />
          <g id="Apps">
            <path d={svgPaths.p989c200} fill="var(--fill-0, #101928)" id="Vector" />
          </g>
        </g>
      </svg>
    </div>
  );
}



function Frame24({
  content,
  fontWeight,
  fontFamily,
  alignment,
  textColor,
  bgColor,
}: {
  content: string;
  fontWeight: string;
  fontFamily: string;
  alignment: string;
  textColor: string;
  bgColor: string;
}) {
  return (
    <div className="h-[479px] relative rounded-[6px] flex-1">
      <div className="overflow-clip relative rounded-[inherit] size-full flex flex-col">
        <p className="css-ew64yg font-['Inter:Semi_Bold',sans-serif] font-semibold leading-[normal] p-4 not-italic text-[#101928] text-[16px]">Text Preview</p>
        <div
          className="flex-1 m-4 flex items-center justify-center overflow-auto relative"
          style={{ backgroundColor: content ? bgColor : "transparent" }}
        >
          {content ? (
            <p
              style={{
                fontWeight: fontWeight,
                fontFamily: fontFamily,
                textAlign: alignment as any,
                color: textColor,
                width: "100%",
                padding: "24px",
                fontSize: "32px",
                lineHeight: "1.5"
              }}
            >
              {content}
            </p>
          ) : (
            <div className="content-stretch flex flex-col gap-[16px] items-center justify-center relative size-full">
              <Frame20 />
              <p className="css-4hzbpn font-['Inter:Regular',sans-serif] font-normal leading-[24px] min-w-full not-italic relative shrink-0 text-[#475367] text-[14px] w-[min-content] text-center">
                To view the data, simply click on the preview button.
              </p>
            </div>
          )}
        </div>
      </div>
      <div aria-hidden="true" className="absolute border border-[#e4e7ec] border-solid inset-0 pointer-events-none rounded-[6px]" />
    </div>
  );
}

function Frame30({
  settings,
  previewData,
  onPreview,
}: {
  settings: TextAppSettings;
  previewData: {
    content: string;
    fontWeight: string;
    fontFamily: string;
    alignment: string;
    textColor: string;
    bgColor: string;
  };
  onPreview: () => void;
}) {
  return (
    <div className="relative content-stretch flex gap-[22px] items-start px-[24px] mt-[20px] w-full">
      <Frame23 {...settings} onPreview={onPreview} />
      <Frame24
        content={previewData.content}
        fontWeight={previewData.fontWeight}
        fontFamily={previewData.fontFamily}
        alignment={previewData.alignment}
        textColor={previewData.textColor}
        bgColor={previewData.bgColor}
      />
    </div>
  );
}

export default function TextApp({ onBack, onCreate }: { onBack?: () => void; onCreate?: (data: any) => void }) {
  const [content, setContent] = useState("");
  const [fontWeight, setFontWeight] = useState("400");
  const [fontFamily, setFontFamily] = useState("Inter");
  const [alignment, setAlignment] = useState("left");
  const [textColor, setTextColor] = useState("#101928");
  const [bgColor, setBgColor] = useState("#FFFFFF");

  const [appName, setAppName] = useState(() => {
    const time = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
    return `Text 01 ${time}`;
  });

  const [previewData, setPreviewData] = useState({
    content: "",
    fontWeight: "400",
    fontFamily: "Inter",
    alignment: "left",
    textColor: "#101928",
    bgColor: "#FFFFFF",
  });

  const settings = {
    content,
    setContent,
    fontWeight,
    setFontWeight,
    fontFamily,
    setFontFamily,
    alignment,
    setAlignment,
    textColor,
    setTextColor,
    bgColor,
    setBgColor,
  };

  const handlePreview = () => {
    setPreviewData({
      content,
      fontWeight,
      fontFamily,
      alignment,
      textColor,
      bgColor,
    });
  };

  const handleCreate = () => {
    if (onCreate) {
      onCreate({
        type: 'text',
        content: appName,
        data: {
          text: content,
          styles: {
            fontWeight,
            fontFamily,
            alignment,
            textColor,
            bgColor
          }
        }
      });
    }
  };

  const isCreateEnabled = content.trim().length > 0;

  return (
    <div className="bg-white overflow-clip relative rounded-[8px] w-full h-fit flex flex-col pb-[32px]" data-name="Text App">
      <NavHeader
        onBack={onBack}
        isActive={isCreateEnabled}
        onCreate={handleCreate}
        appName={appName}
        onAppNameChange={setAppName}
      />
      <Frame30 settings={settings} previewData={previewData} onPreview={handlePreview} />
    </div>
  );
}